// extracted by mini-css-extract-plugin
export var cardHeader = "_ty-0";
export var reorderHandle = "_ty-3";
export var titleArea = "_ty-1";
export var titleAreaWithHandle = "_ty-2";